import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BotId, Dictionary } from '@feedyou/schema'

export interface BotNamesState {
  focus: boolean
  loadingStatusByBotId: Dictionary<BotId, boolean>
}

export const initialState: BotNamesState = {
  focus: false,
  loadingStatusByBotId: {}
}

const slice = createSlice({
  name: 'botNames',
  initialState,
  reducers: {
    setFocus: (state, action: PayloadAction<boolean>) => {
      state.focus = action.payload
    },

    setBotNameLoadingForBotId: (
      state,
      action: PayloadAction<{ botId: string; loading: boolean }>
    ) => {
      const { botId, loading } = action.payload
      state.loadingStatusByBotId[botId] = loading
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
